import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IConstructionStatistics } from "../domain/IConstructionStatistics";
import { IConstructionStatisticsRequestParams } from "../domain/IConstructionStatisticsRequestParams";
import { StatisticsService } from "../services/statistics.service";

interface ConstructionStatisticsState {
  loading: boolean;
  statistics?: IConstructionStatistics;
  error: any;
}

const initialState: ConstructionStatisticsState = {
  loading: false,
  statistics: undefined,
  error: undefined,
};

export const getConstructionStatistics = createAsyncThunk(
  "Statistics/getConstructionStatistics",
  async (data?: IConstructionStatisticsRequestParams) => {
    try {
      const result = await StatisticsService.getConstructionStatistics(data);
      return result;
    } catch (err) {
      setError(err);
    }
  }
);

export const ConstructionStatisticsSlice = createSlice({
  name: "ConstructionStatistics",
  initialState: initialState,
  reducers: {
    setConstructionStatistics: (
      state,
      action: PayloadAction<IConstructionStatistics>
    ) => {
      state.statistics = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getConstructionStatistics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getConstructionStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.statistics = action.payload ? action.payload : undefined;
    });
    builder.addCase(getConstructionStatistics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  }
});

export const selectState = (state: RootState) => state.statistics.construction;

export const { setError } = ConstructionStatisticsSlice.actions;

export default ConstructionStatisticsSlice.reducer;
